<div class="card p-4">
    <div class="flex flex-col items-center flex-auto sm:flex-row sm:items-start mb-8">
        <div class="flex items-center justify-center w-10 h-10 rounded-full flex-0 sm:mr-4  bg-primary">
            <mat-icon class="text-white">pin_drop</mat-icon>
        </div>
        <div class="flex flex-col">
            <div class="text-xl font-medium leading-6">Trouver votre adresse</div>
            <div class="text-secondary text-md">Identifier l'adresse recherchée depuis la liste des suggestions</div>
        </div>
    </div>
    <form [formGroup]="addressAutocompleteFrom" autocomplete="off">
        <mat-form-field class="w-full fuse-mat-no-subscript">
            <input type="text" id="address" [formControlName]="'address'" name="address" matInput
                placeholder="commencez à taper votre adresse"
                [matAutocomplete]="auto">
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
            <mat-option *ngFor="let option of filteredOptions?.features" [value]="option">
                {{option.properties.label}}, France
            </mat-option>
        </mat-autocomplete>

        <div class="flex justify-end mt-8">
            <button mat-button (click)="closeModal()">Annuler</button>
            <button mat-raised-button class="ml-2 bg-accent text-white" [disabled]="!enableSubmitButton"
                (click)="validateAddress()">Valider</button>
        </div>
    </form>
</div>